export enum JournalEntryAction {
  ResourceComplete = 'RESOURCE_COMPLETE',
  Complete = 'COMPLETE',
  Open = 'OPEN',
}
